module.exports = __webpack_public_path__ + "img/国图岛-小图.93b701a6.png";